import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-noticie-email-details',
  templateUrl: './noticie-email-details.component.html',
  styleUrls: ['./noticie-email-details.component.scss']
})
export class NoticieEmailDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
